module.exports = __webpack_public_path__ + "media/images/favicon-d2b70525d8b935755b1924160440d7a1.png";